<!--
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-17 17:36:18
 * @LastEditTime: 2020-08-18 11:21:31
-->
<template>
  <div class="s-table">
    <div
      class="filter-bar"
      v-if="filterVisible">
      <slot name="filter" />
    </div>
    <div
      ref="tableList"
      :class="{'table-list-content': true}"
      :style="`height: calc(100% - ${filterVisible ? '85px': '54px'});`">
      <slot name="list-left" />
      <not-data v-if="!dataSource || dataSource.length === 0" />
      <Table
        v-if="dataSource && dataSource.length > 0"
        :class="`table-list-table ${header ? '' : 'no-header'}`"
        :style="`width: calc(100% - ${listLeftOffset + listRightOffset}px)`"
        :highlight-row="!isMultiple"
        :columns="column"
        :data="dataSource"
        :loading="isLoading"
        :height="tableHeight"
        :border="border"
        :show-header="header"
        ref="table"
        :row-class-name="rowClass"
        @on-current-change="handleSelectionCurrent"
        @on-row-click="rowClick"
        @on-row-dblclick="rowDbClick"
        @on-selection-change="handleSelectionChange" />
      <slot name="list-right" />
    </div>
    <div
      class="page-info"
      v-if="!isEmpty && pageVisible && isshowpage">
      <Page
        class="s-table__page"
        :total="total"
        :show-elevator="showPagelevator"
        :show-sizer="showPageSize"
        :page-size="pageSize"
        :page-size-opts="[10, 15, 20, 25]"
        :current="currentPage"
        placement="top"
        show-total
        @on-page-size-change="changePageSize"
        @on-change="onPageChange" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'STable',
  props: {
    isshowpage: {
      type: Boolean,
      default: () => {
        return true
      },
    },
    list: {
      type: Array,
      default: () => [],
    },
    column: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    filterVisible: {
      type: Boolean,
      default: true,
    },
    pageVisible: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: true,
    },
    isUnchecked: {
      type: [Boolean, Function],
      default: false,
    },
    isChecked: {
      type: [Boolean, Function],
      default: false,
    },
    header: {
      type: Boolean,
      default: true,
    },
    listOffsetWidths: {
      type: Array,
      default: () => [0, 0],
    },
    showPageSize: {
      type: Boolean,
      default: true,
    },
    showPagelevator: {
      type: Boolean,
      default: true,
    },
    pageType: {
      type: String,
      default: '',
    },
    tableColumnsChecked: {
      type: Array,
      default: () => [],
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataSource: [],
      // columnSource: [],
      // tableColumnsCheckedSource: this.tableColumnsChecked,
      baseSource: [],
      tableHeight: this.$el && this.$el.clientHeight - 60,
    }
  },
  computed: {
    isEmpty() {
      return this.list.length === 0
    },
    listLeftOffset() {
      return this.listOffsetWidths[0]
    },
    listRightOffset() {
      return this.listOffsetWidths[1]
    },
  },
  watch: {
    list: function (newList) {
      this.dataSource = this.filterList(newList)
      this.baseSource = []
    },
  },
  mounted() {
    this.dataSource = this.filterList(this.list)
    window.onresize = () => {
      this.tableHeight = this.$refs.tableList.getBoundingClientRect().height - 18
    }
    this.tableHeight = this.$refs.tableList.getBoundingClientRect().height - 18
  },
  methods: {
    onPageChange(page) {
      this.$emit('on-page-change', page)
    },
    changePageSize(size) {
      this.$emit('on-page-size-change', size)
    },
    filterList(list) {
      const dataSource = []
      if (list.length > 0) {
        list.forEach(itm => dataSource.push(this.filterStatus(itm)))
        return dataSource
      }
    },
    resetCheck() {
      this.dataSource = this.dataSource.map(d => this.filterStatus(d))
      this.$emit('on-selection-change', [])
    },
    filterStatus(d) {
      let _disabled = false
      let _checked = false
      if (typeof this.isUnchecked === 'function') {
        _disabled = this.isUnchecked(d)
      } else {
        _disabled = this.isUnchecked
      }
      if (typeof this.isChecked === 'function') {
        _checked = this.isChecked(d)
      } else {
        _checked = this.isChecked
      }
      return {
        ...d,
        _checked,
        _disabled,
      }
    },
    //选中添加类
    rowClass(data, index) {
      for (let i = 0; i < this.baseSource.length; i++) {
        if (index === this.baseSource[i] && data) {
          return 'demo-table-error-row'
        }
      }
    },
    //单击某一行时触发
    rowClick(data, index) {
      this.$refs.table.toggleSelect(index)
      this.$emit('on-row-click', data)
    },
    //获取索引的方法
    getArrIndex(arr, obj) {
      let index = null
      const [key] = [Object.keys(obj)[0]]
      arr.every(function (value, i) {
        if (value[key] === obj[key]) {
          index = i
          return false
        }
        return true
      })
      return index
    },
    //多选框数据
    handleSelectionChange(val) {
      if (this.isMultiple) {
        this.baseSource = []
        for (let i = 0; i < val.length; i++) {
          this.baseSource.push(this.getArrIndex(this.dataSource, val[i]))
        }
        this.$emit('on-selection-change', val)
      }
    },
    // 单选数据
    handleSelectionCurrent(val) {
      this.baseSource = []
      this.baseSource.push(this.dataSource, val[0])
      this.$emit('on-selection-current', val)
      this.$emit('select-row', val)
    },
    //双击某一行
    rowDbClick(data) {
      this.$emit('on-row-dblclick', data)
    },
    /*    filterColumn(list){
        const columnSource = []
        columnSource.push(list[0]);// id
        columnSource.push(list[1]);// 操作
        list.forEach((itm) => {
            this.tableColumnsCheckedSource.forEach((item) => {
                if (itm.title && itm.title === item){
                    columnSource.push(itm)
                }
            })
        })
        return columnSource
    },
    changeTableColumns(){
        this.columnSource = this.filterColumn(this.column);
    }*/
  },
}
</script>
<style>
.s-table .ivu-tooltip {
  /* position: absolute; */
  bottom: 30px;
  left: 20px;
}
.s-table .ivu-checkbox-group .ivu-checkbox-wrapper {
  display: block;
}
.ivu-poptip {
  display: block;
}
.ivu-poptip-rel {
  display: block;
}
.ivu-poptip-popper {
  max-width: 300px;
}
.ivu-poptip-inner {
  white-space: unset;
}
.s-table .ivu-table-cell span,
.s-table .ivu-table-cell .ivu-poptip-rel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.work-mark-content-item {
  position: relative;
}
.s-table .ivu-table-tbody .ivu-table-row{
  background: #fff !important;
}
</style>
<style lang="scss" scoped>
.s-table {
  height: 100%;
  display: flex;
  flex-direction: column;
  .filter-bar {
    padding: 5px 0;
    // height: 50px;
    line-height: 40px;
    text-align: left;
    background-color: #fff;
    position: relative;
  }
  & ::v-deep .ivu-table-wrapper {
    border-bottom: 0;
    border-right: 0;
  }
  .table-list-content {
    display: flex;
    width: 100%;
    position: relative;
    .table-list-table {
      height: 100% !important;
      margin: 10px 0;
      flex: 1;
      & ::v-deep .ivu-table {
        width: 100%;
        .ivu-table-body {
          height: calc(100% - 41px) !important;
          overflow-x: auto;
        }
        .demo-table-error-row td {
          background-color: #ebf7ff;
        }
      }
      & ::v-deep .ivu-table-header th {
        color: #333;
      }
      & ::v-deep .ivu-btn-text {
        background-color: transparent;
        &:hover {
          background-color: #fff;
        }
        &:focus {
          box-shadow: none;
        }
      }
    }
    .no-header {
      & ::v-deep .ivu-table {
        .ivu-table-body {
          height: 100% !important;
          overflow-x: hidden;
        }
      }
    }
    & ::v-deep .ivu-table-tip {
      height: 90%;
      & ::v-deep table {
        height: 100%;
      }
    }
  }
  .s-table__page {
    display: inline-block;
    // margin: 0 auto;
    padding: 0px 20px;
  }
  ::v-deep.ivu-table-fixed {
    height: calc(100% - 18px);
    .ivu-table-fixed-body {
      height: calc(100% - 32px) !important;
    }
  }
  /deep/ .ivu-table-fixed::before,
  /deep/ .ivu-table-fixed-right::before {
    height: 0 !important;
  }
  .page-info {
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 47px;
    align-items: center;
    justify-content: flex-end;
    display: flex;
    .s-table__page {
      display: inline-block;
      // margin: 0 auto;
      padding: 0px 20px;
    }
  }
}
/deep/.ivu-page-item-active {
    background: #1492FF;
}
</style>